import appReducer from '../modules/app/app.reducer';
import registrationReducer from '../modules/app/initial-content/registration/registration.reducer';
import verificationReducer from '../modules/app/initial-content/verification/verification.reducer';
import loginReducer from '../modules/app/initial-content/login/login.reducer';
import forgotPasswordReducer from '../modules/app/initial-content/forgot-password/forgot-password.reducer';
import passwordRecoveryReducer from '../modules/app/initial-content/password-recovery/password-recovery.reducer';
import verificationSetupReducer from '../modules/app/initial-content/verification-setup/verification-setup.reducer';
import logoutReducer from '../modules/app/content/logout/logout.reducer';
import navigationReducer from '../modules/app/navigation/navigation.reducer';
import rightDrawerReducer from '../modules/app/right-drawer/right-drawer.reducer';
import notificationsReducer from '../modules/app/notifications/notifications.reducer';
import commentsReducer from '../modules/app/comments/comments.reducer';
import controlsReducer from '../modules/app/controls/controls.reducer';
import statusFilterReducer from '../modules/app/controls/status-filter/status-filter.reducer';
import portfolioFilterReducer from '../modules/app/controls/portfolio-filter/portfolio-filter.reducer';
import exportModalReducer from '../modules/app/controls/export-modal/export-modal.reducer';
import importModalReducer from '../modules/app/controls/import-modal/import-modal.reducer';
import searchReducer from '../modules/search/search.reducer';
import settingsReducer from '../modules/settings/settings.reducer';
import settingsAccountListReducer from '../modules/settings/settings-account-list/settings-account-list.reducer';
import settingsOperationLogReducer from '../modules/settings/settings-operation-log/settings-operation-log.reducer';
import settingsDealTemplateListReducer
  from '../modules/settings/settings-deal-template-list/settings-deal-template-list.reducer';
import settingsDealTemplateReducer from '../modules/settings/settings-deal-template/settings-deal-template.reducer';
import settingsPortfolioGroupReducer
  from '../modules/settings/settings-portfolio-group/settings-portfolio-group.reducer';
import settingsPortfolioGroupListReducer
  from '../modules/settings/settings-portfolio-group-list/settings-portfolio-group-list.reducer';
import settingsPortfolioReducer from '../modules/settings/settings-portfolio/settings-portfolio.reducer';
import settingsUserListReducer from '../modules/settings/settings-user-list/settings-user-list.reducer';
import settingsUserReducer from '../modules/settings/settings-user/settings-user.reducer';
import dashboardReducer from '../modules/dashboard/dashboard.reducer';
import assetListReducer from '../modules/asset-list/asset-list.reducer';
import assetReducer from '../modules/asset/asset.reducer';
import activityListReducer from '../modules/activity-list/activity-list.reducer';
import activityReducer from '../modules/activity/activity.reducer';
import dealListReducer from '../modules/deal-list/deal-list.reducer';
import dealReducer from '../modules/deal/deal.reducer';
import dealTasksReducer from '../modules/deal/deal-tasks/deal-tasks.reducer';
import dealParticipantsReducer from '../modules/deal/deal-participants/deal-participants.reducer';
import dealFilesReducer from '../modules/deal/deal-files/deal-files.reducer';
import dealScheduleTasksReducer from '../modules/deal/deal-schedule-tasks/deal-schedule-tasks.reducer';
import contactListReducer from '../modules/contact-list/contact-list.reducer';
import contactReducer from '../modules/contact/contact.reducer';
import reportListReducer from '../modules/report-list/report-list.reducer';
import reportReducer from '../modules/report/report.reducer';

export default {
  app: appReducer,
  registration: registrationReducer,
  verification: verificationReducer,
  login: loginReducer,
  forgotPassword: forgotPasswordReducer,
  passwordRecovery: passwordRecoveryReducer,
  verificationSetup: verificationSetupReducer,
  logout: logoutReducer,
  navigation: navigationReducer,
  rightDrawer: rightDrawerReducer,
  notifications: notificationsReducer,
  comments: commentsReducer,
  controls: controlsReducer,
  statusFilter: statusFilterReducer,
  portfolioFilter: portfolioFilterReducer,
  exportModal: exportModalReducer,
  importModal: importModalReducer,
  search: searchReducer,
  settings: settingsReducer,
  settingsAccountList: settingsAccountListReducer,
  settingsDealTemplateList: settingsDealTemplateListReducer,
  settingsDealTemplate: settingsDealTemplateReducer,
  settingsPortfolioGroupList: settingsPortfolioGroupListReducer,
  settingsPortfolioGroup: settingsPortfolioGroupReducer,
  settingsPortfolio: settingsPortfolioReducer,
  settingsUserList: settingsUserListReducer,
  settingsUser: settingsUserReducer,
  settingsOperationLog: settingsOperationLogReducer,
  dashboard: dashboardReducer,
  assetList: assetListReducer,
  asset: assetReducer,
  activityList: activityListReducer,
  activity: activityReducer,
  dealList: dealListReducer,
  deal: dealReducer,
  dealTasks: dealTasksReducer,
  dealParticipants: dealParticipantsReducer,
  dealFiles: dealFilesReducer,
  dealScheduleTasks: dealScheduleTasksReducer,
  contactList: contactListReducer,
  contact: contactReducer,
  reportList: reportListReducer,
  report: reportReducer,
};
